export default __webpack_public_path__ + "static/media/colorWhatIfLow.55792a2d.svg";